import { buildPersonalDashboardDTO } from '../domain/evaluatePersonalDashboard';
import type { PersonalDashboardDTO } from '../domain/reportsPersonalTypes';
import type { ReportsQueryScope } from '../domain/reportsQueryScope';
import { fetchRemotePersonalFacts } from '../infra/reportsPersonalRemoteRepo';
import { fetchWithRetry, isOnline } from '../infra/reportsRemoteRepo';

export type LoadReportsPersonalDashboardParams = {
  branchId: string;
  fromIso: string;
  toIso: string;
  scope: ReportsQueryScope;
  currentUserId?: string | null;
};

export type LoadReportsPersonalDashboardResult = {
  dashboard: PersonalDashboardDTO;
  operatorsForRanking: import('../domain/reportsPersonalTypes').PersonalOperatorFacts[];
};

function buildEmptyDashboardResult(): LoadReportsPersonalDashboardResult {
  const empty = buildPersonalDashboardDTO(
    {
      periodDays: 1,
      branch: {
        salesCount: 0,
        salesTotal: 0,
        ticketAverage: 0,
        orphanSalesCount: 0,
        orphanSalesTotal: 0,
        customLinePct: 0,
      },
      operators: [],
    },
    'device'
  );
  return { dashboard: empty, operatorsForRanking: [] };
}

export async function loadReportsPersonalDashboard(
  params: LoadReportsPersonalDashboardParams
): Promise<LoadReportsPersonalDashboardResult> {
  const { branchId, fromIso, toIso, scope } = params;
  const online = await isOnline();

  if (online) {
    const remote = await fetchWithRetry(() =>
      fetchRemotePersonalFacts(branchId, fromIso, toIso, scope)
    );
    if (remote) {
      const dashboard = buildPersonalDashboardDTO(remote, 'server');
      return { dashboard, operatorsForRanking: remote.operators };
    }
  }

  return buildEmptyDashboardResult();
}
